import * as Types from '@x/schemas/ecommerce';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ShopGeoRegionDetailFragment = { __typename: 'ShopGeoRegionObject', id: number, name: string, code: string, channelCode: string, channelId: number, parentId?: number | null | undefined, label?: string | null | undefined, description?: string | null | undefined, definitions: Array<{ __typename: 'ShopGeoRegionDefinition', id: number, center?: any | null | undefined, boundary?: any | null | undefined }> };

export type ShopGeoRegionItemFragment = { __typename: 'ShopGeoRegionObject', id: number, name: string, code: string, channelCode: string, channelId: number, parentId?: number | null | undefined, label?: string | null | undefined, description?: string | null | undefined };

export type ShopRegionMatchQueryVariables = Types.Exact<{
  address: Types.ShopAddressInput;
}>;


export type ShopRegionMatchQuery = { __typename: 'Query', shopRegionMatch?: { __typename: 'ShopGeoRegionObject', id: number, name: string, code: string, channelCode: string, channelId: number, parentId?: number | null | undefined, label?: string | null | undefined, description?: string | null | undefined, definitions: Array<{ __typename: 'ShopGeoRegionDefinition', id: number, center?: any | null | undefined, boundary?: any | null | undefined }> } | null | undefined };

export const ShopGeoRegionDetailFragmentDoc = gql`
    fragment ShopGeoRegionDetail on ShopGeoRegionObject {
  id
  name
  code
  channelCode
  channelId
  parentId
  label
  description
  definitions {
    id
    center
    boundary
  }
}
    `;
export const ShopGeoRegionItemFragmentDoc = gql`
    fragment ShopGeoRegionItem on ShopGeoRegionObject {
  id
  name
  code
  channelCode
  channelId
  parentId
  label
  description
}
    `;
export const ShopRegionMatchDocument = gql`
    query ShopRegionMatch($address: ShopAddressInput!) {
  shopRegionMatch(address: $address) {
    ...ShopGeoRegionDetail
  }
}
    ${ShopGeoRegionDetailFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopRegionMatchGQL extends Apollo.Query<ShopRegionMatchQuery, ShopRegionMatchQueryVariables> {
    document = ShopRegionMatchDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }